import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { useModal } from 'core/modules/Modal/ModalProvider';

function ProductOverlayLink({
  productId, children, className,
}) {
  const { openModal } = useModal();

  const handleProductClick = () => {
    openModal({
      name: 'mt_productDetails',
      params: { productId },
    });
  };

  const overlayClassName = `mn_productOverlayLink ${className || ''}`;

  return (
    <div className={overlayClassName} role="button" tabIndex="0" onClick={handleProductClick}>
      {children}
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ProductOverlayLink {...props} /></ComponentErrorBoundary>;
